jQuery(function ($) {
    $(document).on('click', '[data-quantity-step]', function () {
        var $button = $(this);
        var $input = $button.closest('.quantity').find('input.qty');

        if (!$input.length || $input.is('[readonly]')) {
            return;
        }

        var direction = $button.data('quantity-step') === 'up' ? 1 : -1;
        var min = parseFloat($input.attr('min'));
        var max = parseFloat($input.attr('max'));
        var step = parseFloat($input.attr('step')) || 1;
        var current = parseFloat($input.val()) || 0;
        var next = current + (step * direction);

        if (!Number.isNaN(min)) {
            next = Math.max(min, next);
        }

        if (!Number.isNaN(max)) {
            next = Math.min(max, next);
        }

        $input.val(next).trigger('change');
    });
});
